
scittle.eql.init();